import { WarningIcon } from '@chakra-ui/icons';
import { Center, CenterProps } from '@chakra-ui/react';
import { FC } from 'react';
import { Text } from './Typography';

export interface ErrorMessageProps extends CenterProps {
    message: string;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message, ...props }) => {
    return (
        <Center w="full" h="full" p={4} {...props}>
            <WarningIcon mr={2} w={4} h={4} color="textMuted" />
            <Text color="textMuted">{message}</Text>
        </Center>
    );
};

export default ErrorMessage;
